
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-c7dc632e!postcss-loader!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CloseButton.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CloseButton.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-c7dc632e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CloseButton.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared-components/CaseStudy/CloseButton.vue
// module id = 241
// module chunks = 0